import { Helmet } from "react-helmet";

const Seo = ({ data = {} }) => {
  const url = `https://wise.com/${data.pathSlug || ""}`;

  return (
    <Helmet
      htmlAttributes={{ lang: "en" }}
      title={data.title || "Wise"}
      meta={[
        {
          name: "description",
          content: data.description || "Default description for Wise project",
        },
        {
          name: "keywords",
          content: data.keywords || "wise, blog, events",
        },
        {
          property: "og:title",
          content: data.title || "Wise",
        },
        {
          property: "og:description",
          content: data.description || "Default description for Wise project",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:url",
          content: url,
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
        {
          name: "twitter:title",
          content: data.title || "Wise",
        },
        {
          name: "twitter:description",
          content: data.description || "Default description for Wise project",
        },
      ]}
      link={[
        {
          rel: "canonical",
          href: url,
        },
      ]}
    />
  );
};

export default Seo;
